import React from 'react';
import { Shield, Users, Target } from 'lucide-react';
import { SkillsSectionProps } from '@/types';

const SkillsSection: React.FC<SkillsSectionProps> = ({ skills }) => {
  return (
    <section id="skills" className="py-20 bg-gray-800/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            Core Technical Skills
          </h2>
          <p className="text-xl text-gray-300">
            Expertise in modern cloud technologies and infrastructure management
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-16">
          {skills.map((skill, index) => {
            const IconComponent = skill.icon;
            return (
              <div key={index} className="bg-gray-900/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500/50 transition-all duration-300 transform hover:scale-105 text-center">
                <div className="text-blue-400 mb-3 flex justify-center">
                  <IconComponent className="w-6 h-6" />
                </div>
                <div className="font-semibold text-white mb-1">{skill.name}</div>
                <div className="text-sm text-gray-400">{skill.category}</div>
              </div>
            );
          })}
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-gray-900/50 p-8 rounded-2xl border border-gray-700">
            <Shield className="w-12 h-12 text-blue-400 mb-4" />
            <h3 className="text-xl font-bold text-white mb-4">Security & Compliance</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Zero trust architecture design</li>
              <li>• IAM, SSO, RBAC, OIDC, OAuth</li>
              <li>• CIS Benchmarks compliance</li>
            </ul>
          </div>

          <div className="bg-gray-900/50 p-8 rounded-2xl border border-gray-700">
            <Users className="w-12 h-12 text-purple-400 mb-4" />
            <h3 className="text-xl font-bold text-white mb-4">Leadership</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Technical mentorship & training</li>
              <li>• Cross-functional collaboration</li>
              <li>• Project management & ownership</li>
            </ul>
          </div>

          <div className="bg-gray-900/50 p-8 rounded-2xl border border-gray-700">
            <Target className="w-12 h-12 text-green-400 mb-4" />
            <h3 className="text-xl font-bold text-white mb-4">Certifications</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• AWS Solutions Architect</li>
              <li>• Project Management Certificate</li>
              <li>• Applied Mathematics Degree</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;